import RugCardDetailedActions from './RugCardDetailedActions'
export default RugCardDetailedActions
